/* istanbul ignore file */
import { Routes } from 'react-router-dom';
// components
import ContactContext from 'domain/sales/contact/ContactContext';
import ContactTimelinePage from 'domain/sales/contact/Timeline';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import ContactRelatedOpportunities from 'domain/sales/contact/Show/ContactRelatedOpportunities';
import { CreateContact, UpdateContact } from 'domain/sales/contact/createupdate';
import ListPage from 'domain/sales/contact/list';
import ViewPage from 'domain/sales/contact/Show';
import ShowContact from 'domain/sales/contact/shared/ShowContact';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route } from 'framework/routing';
// services
import { READ_TIMELINE } from 'domain/sales/salesService';
import { READ, UPDATE } from 'domain/shared/core/permissions';
import { READ_CONTACTS_LIST, CREATE_CONTACT } from 'domain/sales/contact/shared/contactService';
import { CONTACTS_PATH, useContactRoute } from './contactRouting';

const ContactRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    createRoute: createEntityRoute,
    updateRoute,
    timelineRoute,
    singleEntityRoute,
    relatedOpportunitiesRoute,
  } = useContactRoute();

  return (
    <ProtectedRouter basePath={CONTACTS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_CONTACTS_LIST}>
              <ListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_CONTACT}>
              <CreateContact />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={updateRoute}
          element={
            <ContactContext permissionToCheck={UPDATE}>
              <UpdateContact />
            </ContactContext>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <ContactContext permissionToCheck={READ}>
              <ViewPage />
            </ContactContext>
          }
        />

        <Route
          path={timelineRoute}
          element={
            <ContactContext permissionToCheck={READ_TIMELINE}>
              <ContactTimelinePage />
            </ContactContext>
          }
        />

        <Route
          path={relatedOpportunitiesRoute}
          element={
            <ContactContext permissionToCheck={READ}>
              <ShowContact>
                <ContactRelatedOpportunities />
              </ShowContact>
            </ContactContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ContactRouter.getRouterPath = () => '/contacts/*';

export default ContactRouter;
